module.exports = __webpack_public_path__ + "media/images/expert__bruno-berner-a495efb295e142915a70464ef906b7c6.png";